"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.63 4.333A4.322 4.322 0 0 0 7.95 8.65a4.323 4.323 0 0 0 4.32-4.316A4.325 4.325 0 0 0 7.95.014a4.324 4.324 0 0 0-4.318 4.32Zm1 0a3.322 3.322 0 0 1 3.319-3.32 3.323 3.323 0 0 1 3.32 3.32 3.322 3.322 0 0 1-3.32 3.316A3.32 3.32 0 0 1 4.63 4.333Zm9.837 11.647h-1a5.473 5.473 0 0 0-2.935-4.845L9.047 12.62a1.456 1.456 0 0 1-1.033.427c-.374 0-.748-.142-1.033-.427l-1.494-1.494a5.473 5.473 0 0 0-2.953 4.854h-1A6.474 6.474 0 0 1 8 9.513a6.474 6.474 0 0 1 6.466 6.467Zm-7.969-5.257 1.19 1.19c.18.18.472.18.652 0l1.184-1.184a5.45 5.45 0 0 0-3.026-.006Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.22 1.124A5.23 5.23 0 0 0 6.996 6.35a5.228 5.228 0 0 0 5.224 5.22 5.23 5.23 0 0 0 5.226-5.22 5.232 5.232 0 0 0-5.226-5.226Zm0 11.57A6.353 6.353 0 0 1 5.872 6.35 6.356 6.356 0 0 1 12.22 0a6.357 6.357 0 0 1 6.35 6.35c0 3.5-2.849 6.345-6.35 6.345ZM21.902 24h-1.125a8.489 8.489 0 0 0-4.681-7.58l-2.35 2.35c-.381.381-.889.59-1.428.59a2.008 2.008 0 0 1-1.427-.59l-2.363-2.364A8.489 8.489 0 0 0 3.819 24H2.695c0-5.296 4.308-9.604 9.603-9.604s9.604 4.308 9.604 9.604ZM9.654 15.943l2.033 2.032a.915.915 0 0 0 1.263 0l2.023-2.022a8.448 8.448 0 0 0-2.675-.432c-.923 0-1.812.148-2.644.422Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16.293 1.499c-3.84 0-6.965 3.126-6.965 6.968 0 3.838 3.125 6.96 6.965 6.96 3.842 0 6.968-3.122 6.968-6.96a6.976 6.976 0 0 0-6.968-6.968Zm0 15.428c-4.666 0-8.464-3.795-8.464-8.46C7.83 3.798 11.627 0 16.293 0c4.669 0 8.467 3.798 8.467 8.467 0 4.665-3.798 8.46-8.467 8.46ZM29.203 32h-1.5c0-4.415-2.543-8.247-6.242-10.107l-3.133 3.133a2.671 2.671 0 0 1-1.903.788c-.719 0-1.394-.28-1.903-.788l-3.151-3.151C7.652 23.728 5.092 27.57 5.092 32H3.593c0-7.06 5.744-12.805 12.805-12.805 7.06 0 12.805 5.744 12.805 12.805ZM12.872 21.257l2.71 2.71c.451.45 1.237.45 1.685 0l2.697-2.696a11.26 11.26 0 0 0-3.566-.577c-1.23 0-2.416.198-3.526.563Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M23.135 1.875c-5.889 0-10.68 4.793-10.68 10.685 0 5.886 4.791 10.674 10.68 10.674 5.892 0 10.686-4.788 10.686-10.674 0-5.892-4.794-10.685-10.686-10.685Zm0 23.234c-6.922 0-12.555-5.63-12.555-12.549C10.58 5.635 16.213 0 23.136 0c6.926 0 12.56 5.635 12.56 12.56 0 6.92-5.634 12.549-12.56 12.549ZM42.385 48H40.51c0-6.866-4.04-12.807-9.868-15.57l.177.178-4.756 4.755a3.85 3.85 0 0 1-2.73 1.13 3.85 3.85 0 0 1-2.73-1.13l-4.756-4.755.248-.249C10.185 35.089 6.074 41.073 6.074 48H4.199c0-10.528 8.565-19.093 19.093-19.093 10.527 0 19.093 8.565 19.093 19.093ZM17.629 31.738l4.3 4.3a1.99 1.99 0 0 0 2.808 0l4.278-4.278a17.144 17.144 0 0 0-5.723-.978 17.16 17.16 0 0 0-5.663.956Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M30.846 2.5c-7.851 0-14.24 6.39-14.24 14.247 0 7.848 6.389 14.232 14.24 14.232 7.856 0 14.248-6.384 14.248-14.232 0-7.856-6.392-14.247-14.248-14.247Zm0 30.979c-9.23 0-16.739-7.506-16.739-16.732C14.107 7.513 21.617 0 30.847 0c9.234 0 16.747 7.513 16.747 16.747 0 9.226-7.513 16.732-16.748 16.732ZM56.512 64h-2.5c0-9.155-5.386-17.075-13.156-20.759l.236.236-6.341 6.34a5.134 5.134 0 0 1-3.64 1.506 5.133 5.133 0 0 1-3.641-1.505l-6.341-6.341.331-.332C13.58 46.785 8.098 54.765 8.098 64h-2.5c0-14.037 11.42-25.457 25.457-25.457S56.513 49.963 56.513 64ZM23.505 42.318l5.733 5.733a2.653 2.653 0 0 0 3.745 0l5.704-5.705a22.86 22.86 0 0 0-7.631-1.303c-2.644 0-5.185.449-7.55 1.275Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconAboutMe = function IconAboutMe(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'About Me' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "AboutMe"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconAboutMe.sizes = [16, 24, 32, 48, 64];
IconAboutMe.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconAboutMe;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/AboutMe.js
// module id = 1584
// module chunks = 0